import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { IMAGE_PROVIDER_TYPES } from 'js/config/consts';
import { canvasSizes } from 'js/config/defaults';
import { useAppSelector } from 'js/store/hooks';
import { getScribeById } from 'js/sagas/selectors';
import { ImageSource } from 'js/types';
import { SearchType } from 'js/reducers/imageSearchReducer';

import { useLibraries } from '../../hooks/useLibraries';

import useGetSearchResult from './useGetSearchResult';

const useFormatAddImageData = (searchType: SearchType, searchInput: string, categoryId: string | null) => {
  const { scribeId } = useParams<{ scribeId: string }>();
  const activeScribe = useAppSelector(state => getScribeById(state, parseInt(scribeId)));

  const { getExistingTabResult } = useGetSearchResult(searchType, searchInput, categoryId);

  const [_, libraries] = useLibraries();

  return useCallback(
    (selectedTab: ImageSource, imageId: string | number) => {
      const tabImages = getExistingTabResult(selectedTab)?.images ?? [];
      const image = tabImages.find(image => image.id === imageId);
      if (!image || !activeScribe) return;
      const contentType = image.contentType ?? 'image/*';
      const category = categoryId ? libraries.find(library => library.id === categoryId)?.title : undefined;

      let searchSource;
      if (image.source === 'streamline') {
        searchSource = IMAGE_PROVIDER_TYPES.STREAMLINE;
      } else if (selectedTab === 'videoscribe') {
        searchSource = IMAGE_PROVIDER_TYPES.LIBRARY;
      } else {
        searchSource = IMAGE_PROVIDER_TYPES.NOUN_PROJECT;
      }

      return {
        imageId: image.id,
        contentType,
        scribeId: activeScribe.id,
        canvasSize: canvasSizes[activeScribe.canvasSize],
        category,
        filename: image.title,
        provider: searchSource,
        sourceType: image.sourceType,
        isPremium: image.isPremium
      };
    },
    [getExistingTabResult, activeScribe, categoryId, libraries]
  );
};

export default useFormatAddImageData;
